import { Link } from 'react-router-dom'
import Page from './Page'
import ProjectList from '../components/ProjectList'
import Icon from '../components/Icon'
import projects from '../constants/works'

const Portfolio = () => (
  <Page>
    <section className='mx-auto max-w-page px-gutter pt-6 md:pt-8'>
      <Link
        to='/#work'
        className='lettering inline-flex items-center gap-2 text-[1.25rem] underline-offset-4 hover:underline'
      >
        <Icon name='right' className='size-5 rotate-180' /> Back
      </Link>
      <div className='mb-4 mt-4 flex flex-wrap items-end justify-between gap-x-8 gap-y-2 md:mb-5'>
        <h1 className='font-display uppercase text-display'>All projects</h1>
        <p className='lettering pb-2 text-[1.25rem]'>
          {projects.length} sites and apps, client work and my own builds
        </p>
      </div>
      <ProjectList items={projects} />
    </section>
  </Page>
)

export default Portfolio
